import { Timespan, Compare } from '../constants';
import { timespanPresets, comparePresets } from './timePresets';
import { yearOrShorter, intervalInside, totalInterval } from './time';

export const totalTimespanInterval = (
  timespan,
  timeBounds,
  customTimespanInterval,
) =>
  timeBounds
    ? timespan === Timespan.CUSTOM && customTimespanInterval
      ? customTimespanInterval
      : timespanPresets[timespan](timeBounds)
    : null;

export const compareIntervals = (
  timespanInterval,
  compare,
  customCompareInterval,
  timeBounds,
) =>
  timeBounds
    ? compare === Compare.CUSTOM && customCompareInterval
      ? [customCompareInterval]
      : comparePresets[compare](timespanInterval, timeBounds)
    : [];

export const totalCompareInterval = intervals =>
  intervals.length > 0 ? totalInterval(intervals) : null;

export const isValidCompare = (
  timeBounds,
  timespan,
  customTimespanInterval,
  compare,
) => {
  if (!timeBounds) return true;
  if (compare === Compare.CUSTOM || compare === Compare.NONE) return true;

  const timespanInterval = totalTimespanInterval(
    timespan,
    timeBounds,
    customTimespanInterval,
  );

  if (
    (compare === Compare.YEAR || compare === Compare.RECURRING) &&
    !yearOrShorter(timespanInterval)
  ) {
    return false;
  }

  const compareInterval = totalCompareInterval(
    compareIntervals(timespanInterval, compare, null, timeBounds),
  );

  return intervalInside(compareInterval, timeBounds);
};

export const availableCompare = (
  timeBounds,
  timespan,
  customTimespanInterval,
) =>
  timeBounds
    ? Object.keys(comparePresets).filter(compare =>
        isValidCompare(timeBounds, timespan, customTimespanInterval, compare),
      )
    : Object.keys(comparePresets);



// WEBPACK FOOTER //
// ./src/utils/intervals.js